import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';

export const LANGUAGE_STORAGE_KEY = 'aidagis.language';
export const DEFAULT_LANGUAGE = 'ru';
// Temporary visibility switch: enable again without restoring or changing translations.
export const UZBEK_ENABLED = false;
const LANGUAGE_CATALOG = [
  { code: 'uz', name: 'O‘zbekcha', flag: '/flags/uz.svg' },
  { code: 'en', name: 'English', flag: '/flags/en.svg' },
  { code: 'ru', name: 'Русский', flag: '/flags/ru.svg' },
  { code: 'tg', name: 'Тоҷикӣ', flag: '/flags/tg.svg' },
];
export const LANGUAGES = LANGUAGE_CATALOG.filter(item => item.code !== 'uz' || UZBEK_ENABLED);
export const translations = {
  tg: {
    navOfferings: 'Пешниҳодҳо', navSolvedTasks: 'Масъалаҳои ҳалшуда', navContacts: 'Тамос',
    chooseLanguage: 'Забонро интихоб кунед', changeLanguage: 'Иваз кардани забон', languageChanged: 'Забони интихобшуда: {name}',
    home: 'Ба оғоз', replay: 'Такрори аниматсияи муқаддима', enableMotion: 'Фаъол кардани аниматсия', reduceMotion: 'Кам кардани ҳаракат',
    openMenu: 'Кушодани меню', closeMenu: 'Пӯшидани меню', sections: 'Бахшҳо', navigation: 'Гузариш байни саҳнаҳо',
    scene: 'Саҳнаи 3D', products: 'Пешниҳодҳои мо барои Тоҷикистон', shapes: 'Шаклҳои пикселӣ', objects: 'Масъалаҳое, ки мо ҳал кардем', projectsSocialProof: 'Зиёда аз 200 муштарии қаноатманд дар саросари ҷаҳон', orbital: 'Равиши мо', studies: 'Дастаи AIDAGIS', particles: 'Нишон аз зарраҳо',
    viewpoint: 'Намои {n}', pixelShape: 'Шакли пикселии {n}', visualStudy: 'Тасвири {n}: иваз кардани ритм',
    illustration: 'Тасвири интерактивии нуқтагии {n}', sculpture: 'Ҳайкали интерактивии пикселии {n}',
    nextScene: 'Гузариш ба саҳнаи навбатӣ', returnTop: 'Бозгашт ба аввали саҳифа',
    heroCanvas: 'Нахли сеченака дар биёбони вокселӣ', palmImage: 'Нахли вокселӣ',
    orbitalCanvas: 'Объекти мадории ҳаракаткунанда, ки аз пикселҳо пайдо мешавад',
    footerCanvas: 'AG AIDAGIS — нишони интерактивӣ аз зарраҳо',
    webglUnavailable: 'Дар ин браузер намоиши 3D дастрас нест', loading: 'Саҳна бор шуда истодааст',
    description: 'AIDAGIS — фазои визуалии интерактивӣ',
  },
  uz: {
    navOfferings: 'Takliflar', navSolvedTasks: 'Hal qilingan vazifalar', navContacts: 'Aloqa',
    chooseLanguage: 'Tilni tanlang', changeLanguage: 'Tilni o‘zgartirish', languageChanged: 'Til o‘zgartirildi: {name}',
    home: 'Boshiga qaytish', replay: 'Kirish animatsiyasini takrorlash', enableMotion: 'Animatsiyani yoqish', reduceMotion: 'Harakatni kamaytirish',
    openMenu: 'Menyuni ochish', closeMenu: 'Menyuni yopish', sections: 'Bo‘limlar', navigation: 'Sahnalar bo‘yicha navigatsiya',
    scene: '3D sahna', products: 'O‘zbekiston uchun takliflarimiz', shapes: 'Pikselli shakllar', objects: 'Biz hal qilgan vazifalar', projectsSocialProof: 'Dunyo bo‘ylab 200+ mamnun mijoz', orbital: 'Yondashuvimiz', studies: 'AIDAGIS odamlari', particles: 'Zarrali logotip',
    viewpoint: '{n}-rakurs', pixelShape: '{n}-pikselli shakl', visualStudy: '{n}-vizual etyud: ritmni o‘zgartirish',
    illustration: '{n}-interaktiv nuqtali tasvir', sculpture: '{n}-interaktiv pikselli haykal',
    nextScene: 'Keyingi sahnaga o‘tish', returnTop: 'Sahifa boshiga qaytish',
    heroCanvas: 'Vokselli cho‘ldagi uch o‘lchamli palma', palmImage: 'Vokselli palma',
    orbitalCanvas: 'Piksellardan paydo bo‘ladigan kinetik orbital obyekt',
    footerCanvas: 'AG AIDAGIS — zarralardan iborat interaktiv logotip',
    webglUnavailable: 'Bu brauzerda 3D mavjud emas', loading: 'Sahna yuklanmoqda',
    description: 'AIDAGIS — interaktiv vizual tajriba',
  },
  en: {
    navOfferings: 'Offerings', navSolvedTasks: 'Solved challenges', navContacts: 'Contacts',
    chooseLanguage: 'Choose a language', changeLanguage: 'Change language', languageChanged: 'Language changed to {name}',
    home: 'Back to start', replay: 'Replay intro', enableMotion: 'Enable animation', reduceMotion: 'Reduce motion',
    openMenu: 'Open menu', closeMenu: 'Close menu', sections: 'Sections', navigation: 'Scene navigation',
    scene: '3D scene', products: 'Our offerings', shapes: 'Pixel forms', objects: 'Challenges We’ve Solved', projectsSocialProof: '200+ satisfied clients worldwide', orbital: 'Our approach', studies: 'People of AIDAGIS', particles: 'Particle logo',
    viewpoint: 'Viewpoint {n}', pixelShape: 'Pixel form {n}', visualStudy: 'Visual study {n}: change rhythm',
    illustration: 'Interactive dot illustration {n}', sculpture: 'Interactive pixel sculpture {n}',
    nextScene: 'Scroll to the next scene', returnTop: 'Return to top',
    heroCanvas: 'Three-dimensional palm in a voxel desert', palmImage: 'Voxel palm',
    orbitalCanvas: 'Kinetic orbital object emerging from pixels',
    footerCanvas: 'AG AIDAGIS — interactive particle logo',
    webglUnavailable: '3D is unavailable in this browser', loading: 'Loading the scene',
    description: 'AIDAGIS — an interactive visual experience',
  },
  ru: {
    navOfferings: 'Предложения', navSolvedTasks: 'Решённые задачи', navContacts: 'Контакты',
    chooseLanguage: 'Выберите язык', changeLanguage: 'Сменить язык', languageChanged: 'Выбран язык: {name}',
    home: 'В начало', replay: 'Повторить вступление', enableMotion: 'Включить анимацию', reduceMotion: 'Уменьшить движение',
    openMenu: 'Открыть меню', closeMenu: 'Закрыть меню', sections: 'Разделы', navigation: 'Навигация по сценам',
    scene: '3D-сцена', products: 'Наши предложения', shapes: 'Пиксельные формы', objects: 'Наши решённые задачи', projectsSocialProof: '200+ довольных клиентов по всему миру', orbital: 'Наш подход', studies: 'Люди AIDAGIS', particles: 'Логотип из частиц',
    viewpoint: 'Ракурс {n}', pixelShape: 'Пиксельная форма {n}', visualStudy: 'Визуальный этюд {n}: изменить ритм',
    illustration: 'Интерактивная точечная иллюстрация {n}', sculpture: 'Интерактивная пиксельная скульптура {n}',
    nextScene: 'Прокрутить к следующей сцене', returnTop: 'Вернуться в начало',
    heroCanvas: 'Объёмная пальма в воксельной пустыне', palmImage: 'Воксельная пальма',
    orbitalCanvas: 'Кинетический орбитальный объект, проявляющийся из пикселей',
    footerCanvas: 'AG AIDAGIS — интерактивный логотип из частиц',
    webglUnavailable: '3D недоступно в этом браузере', loading: 'Загрузка сцены',
    description: 'AIDAGIS — интерактивное визуальное пространство',
  },
};
export const isLanguage = code => LANGUAGES.some(item => item.code === code);
export const normalizeLanguage = code => isLanguage(code) ? code : DEFAULT_LANGUAGE;
function initialLanguage() {
  try { return normalizeLanguage(localStorage.getItem(LANGUAGE_STORAGE_KEY)); }
  catch { return DEFAULT_LANGUAGE; }
}
const I18nContext = createContext(null);
export function I18nProvider({ children }) {
  const [language, setCurrentLanguage] = useState(initialLanguage);
  const [announced, setAnnounced] = useState(false);
  const setLanguage = useCallback(code => {
    const nextLanguage = normalizeLanguage(code);
    setCurrentLanguage(nextLanguage); setAnnounced(true);
    try { localStorage.setItem(LANGUAGE_STORAGE_KEY, nextLanguage); } catch { /* Storage is optional; the language still changes. */ }
  }, []);
  const t = useCallback((key, values = {}) => {
    const text = translations[language][key] ?? translations.en[key] ?? key;
    return text.replace(/\{(\w+)\}/g, (match, name) => values[name] ?? match);
  }, [language]);
  useEffect(() => {
    // Migrate a previously saved, now-disabled locale before the next visit.
    try { localStorage.setItem(LANGUAGE_STORAGE_KEY, language); } catch { /* Rendering does not require storage. */ }
    document.documentElement.lang = language;
    document.documentElement.dir = 'ltr';
    document.querySelector('meta[name="description"]')?.setAttribute('content', translations[language].description);
  }, [language]);
  const value = useMemo(() => ({ language, setLanguage, t }), [language, setLanguage, t]);
  return <I18nContext.Provider value={value}>{children}<span className="sr-only" role="status" aria-live="polite" data-testid="language-announcement">{announced ? t('languageChanged', { name: LANGUAGES.find(l => l.code === language).name }) : ''}</span></I18nContext.Provider>;
}
export function useI18n() {
  const value = useContext(I18nContext);
  if (!value) throw new Error('useI18n requires I18nProvider');
  return value;
}
